import {
  InjectionToken,
  NgModule,
  PLATFORM_INITIALIZER,
  CSP_NONCE,
} from "@angular/core";
import {
  BrowserModule,
  Meta,
  bootstrapApplication,
} from "@angular/platform-browser";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgOptimizedImage } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { AppRoutingModule } from "./app-routing.module";
import {
  AppComponent,
  CustomPaginatorIntl,
  FirstDayIntlService,
} from "./app.component";

import { MaterialExampleModule } from "../material.module";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from "@angular/material/core";
import { MAT_DATE_FORMATS } from "@angular/material/core";

//Librerias
import { ToastrModule } from "ngx-toastr";
import { GaugesModule } from "@biacsics/ng-canvas-gauges";

//Components
import { WelcomeComponent } from "./components/welcome/welcome.component";
import { HomeComponent } from "./components/home/home.component";
import { HomeContentComponent } from "./components/home/home-content/home-content.component";
import { DispositivosComponent } from "./components/home/dispositivos/dispositivos.component";
import { AgregarDispositivoComponent } from "./components/home/agregar-dispositivo/agregar-dispositivo.component";
import { ClientesComponent } from "./components/home/clientes/clientes.component";
import { AgregarClienteComponent } from "./components/home/agregar-cliente/agregar-cliente.component";
import { UsuariosComponent } from "./components/home/usuarios/usuarios.component";
import { AgregarUsuarioComponent } from "./components/home/agregar-usuario/agregar-usuario.component";
import { EstadisticasComponent } from "./components/home/estadisticas/estadisticas.component";
import { MercadoCanalejasComponent } from "./components/home/mercado-canalejas/mercado-canalejas.component";
import { MegaComponent } from "./components/home/mega/mega.component";
import { VerDispositivoComponent } from "./components/home/ver-dispositivo/ver-dispositivo.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { LoginComponent } from "./components/login/login.component";

//Services
import { CookieService } from "ngx-cookie-service";
import { DeviceService } from "./services/device.service";
import { EditarDispositivoComponent } from "./components/home/editar-dispositivo/editar-dispositivo.component";
import { EditarUsuarioComponent } from "./components/home/editar-usuario/editar-usuario.component";
import { EditarClienteComponent } from "./components/home/editar-cliente/editar-cliente.component";
import { OlvidoContrasenaComponent } from "./components/olvido-contrasena/olvido-contrasena.component";
import { CambiarContrasenaComponent } from "./components/cambiar-contrasena/cambiar-contrasena.component";
import { EstablecimientosComponent } from "./components/home/establecimientos/establecimientos.component";
import { AgregarEstablecimientoComponent } from "./components/home/agregar-establecimiento/agregar-establecimiento.component";
import { EditarEstablecimientoComponent } from "./components/home/editar-establecimiento/editar-establecimiento.component";
import { VerEstablecimientoComponent } from "./components/home/ver-establecimiento/ver-establecimiento.component";
import { VerEstablecimientoCompletoComponent } from "./components/home/ver-establecimiento-completo/ver-establecimiento-completo.component";
import { AlarmasComponent } from "./components/home/alarmas/alarmas.component";
import { PerfilComponent } from "./components/home/perfil/perfil.component";
import { MapaEstablecimientosComponent } from "./components/home/mapa-establecimientos/mapa-establecimientos.component";
import { EstadisticasConsumoComponent } from "./components/home/estadisticas-consumo/estadisticas-consumo.component";
import { AgregarTanqueComponent } from "./components/home/agregar-tanque/agregar-tanque.component";
import { TanquesComponent } from "./components/home/tanques/tanques.component";
import { AgregarCervezaComponent } from "./components/home/agregar-cerveza/agregar-cerveza.component";
import { CervezasComponent } from "./components/home/cervezas/cervezas.component";
import { EditarCervezaComponent } from "./components/home/editar-cerveza/editar-cerveza.component";
import { AgregarAlarmasComponent } from "./components/home/agregar-alarmas/agregar-alarmas.component";
import { VerCervezaComponent } from "./components/home/ver-cerveza/ver-cerveza.component";
import { EditarTanqueComponent } from "./components/home/editar-tanque/editar-tanque.component";
import { VerTanqueComponent } from "./components/home/ver-tanque/ver-tanque.component";
import { AlarmasHistorialComponent } from "./components/home/alarmas-historial/alarmas-historial.component";
import { RecargasHistorialComponent } from "./components/home/recargas-historial/recargas-historial.component";
import { AgregarPedidoComponent } from "./components/home/agregar-pedido/agregar-pedido.component";
import { PedidosComponent } from "./components/home/pedidos/pedidos.component";
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

//Environments
import { environment } from "./../environments/environment";
import { NonceService } from "./services/nonce.service";
import { HomeEstablecimientosComponent } from "./components/home/home-establecimientos/home-establecimientos.component";
import { ConfiguracionAlarmasComponent } from "./components/home/configuracion-alarmas/configuracion-alarmas.component";
import { VerDispositivoDatosComponent } from "./components/home/ver-dispositivo-datos/ver-dispositivo-datos.component";

//Exports
//export const CSP_NONCE = new InjectionToken<string>('cspNonce');
export function cspNonceProviderFactory() {
  console.log(CSP_NONCE);
  //return "8uFk9eLB24Xj7MzLEMFKKPRW8Vy0qS5B";
  //return (globalThis as any).myRandomNonceValue;
}

//Internacionalización
/*import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es'; */

@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    HomeComponent,
    HomeContentComponent,
    DispositivosComponent,
    AgregarDispositivoComponent,
    ClientesComponent,
    AgregarClienteComponent,
    UsuariosComponent,
    AgregarUsuarioComponent,
    EstadisticasComponent,
    MercadoCanalejasComponent,
    MegaComponent,
    VerDispositivoComponent,
    PageNotFoundComponent,
    LoginComponent,
    EditarDispositivoComponent,
    EditarUsuarioComponent,
    EditarClienteComponent,
    OlvidoContrasenaComponent,
    CambiarContrasenaComponent,
    EstablecimientosComponent,
    AgregarEstablecimientoComponent,
    EditarEstablecimientoComponent,
    VerEstablecimientoComponent,
    AlarmasComponent,
    PerfilComponent,
    MapaEstablecimientosComponent,
    EstadisticasConsumoComponent,
    AgregarTanqueComponent,
    TanquesComponent,
    AgregarCervezaComponent,
    CervezasComponent,
    EditarCervezaComponent,
    AgregarAlarmasComponent,
    VerCervezaComponent,
    EditarTanqueComponent,
    VerTanqueComponent,
    AlarmasHistorialComponent,
    RecargasHistorialComponent,
    AgregarPedidoComponent,
    PedidosComponent,
    HomeEstablecimientosComponent,
    VerEstablecimientoCompletoComponent,
    ConfiguracionAlarmasComponent,
    VerDispositivoDatosComponent,
  ],
  imports: [
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.msal.clientId,
          authority: environment.msal.authority,
          redirectUri: environment.msal.redirectUri
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: false,
        }
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: environment.msal.scopes
        }
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['user.read']]
        ])
      }
    ),
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    MaterialExampleModule,
    NgOptimizedImage,
    GaugesModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    MatPaginatorModule,
    MatSortModule,
  ],
  providers: [
    CookieService,
    DeviceService,
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    { provide: DateAdapter, useClass: FirstDayIntlService },
    { provide: MAT_DATE_LOCALE, useValue: "es-ES" },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: "DD/MM/YYYY",
        },
        display: {
          dateInput: "input",
          monthYearLabel: "MMM YYYY",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "MMMM YYYY",
        },
      },
    },
    //{provide: CSP_NONCE, useValue: this.nonce}
    /*{ provide: CSP_NONCE, useFactory: cspNonceProviderFactory},
    { provide: PLATFORM_INITIALIZER, useFactory: (cspNonceProviderFactory: any) => () => {
        return bootstrapApplication(AppComponent, {
          providers: [
            { provide: CSP_NONCE, useValue: cspNonceProviderFactory },
          ]
        });
      }, deps: [CSP_NONCE], multi: true,
    },*/
    /*{
      provide: CSP_NONCE,
      useFactory: (nonceService: NonceService) => nonceService.getNonce(),
      deps: [NonceService],
    },*/
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  nonce: any;

  constructor(private meta: Meta, private nonceService: NonceService) {
    //this.nonceService.getNonce().subscribe(nonce => {
    //console.log(nonce);
    //this.nonce = nonce;
    /*const cspDirective = `
        default-src 'self'; 
        script-src 'self' 'nonce-${this.nonce}' https://maps.googleapis.com; 
        style-src 'self' 'nonce-${this.nonce}' https://fonts.googleapis.com; 
        img-src 'self'; 
        connect-src 
          'self' 
          https://databeer.ccdatos.com 
          https://backoffice-databeer.staging.ccdatos.com 
          https://telemetriapre.estrellagalicia.es/back 
          https://www.google-analytics.com 
          https://maps.googleapis.com 
          https://maps.gstatic.com 
          https://khms1.googleapis.com 
          https://khms0.googleapis.com
          https://databeer.perfectnumbers.tech/;
        font-src 'self' https://fonts.gstatic.com;
        object-src 'self'; 
        media-src 'self'; 
        frame-src 'self'; 
        frame-ancestors 'self'; 
        form-action 'self'; 
        base-uri 'self'; 
        sandbox allow-scripts
      `;
      this.meta.addTags([
        { name: 'Strict-Transport-Security', content: 'max-age=31536000; includeSubDomains' },
        { name: "X-Content-Type-Options", content: "nosniff"},
        { name: "X-Frame-Options", content: "SAMEORIGIN"},
        { name: "Referrer-Policy", content: "no-referrer"},
        { name: "Permissions-Policy", content: "* = *"},
        { name: "Expect-CT", content: "max-age=86400"},
        { name: "Cross-Origin-Embedder-Policy", content: "unsafe-none"},
        { name: "Cross-Origin-Resource-Policy", content: "cross-origin"},
        { name: "Cross-Origin-Opener-Policy", content: "unsafe-none"},
        { name: 'Content-Security-Policy', content: cspDirective }
      ]);*/
    //});
    //this.loadGoogleapi();
  }

  /*loadGoogleapi() {
    const scriptSrc = "https://maps.googleapis.com/maps/api/js?key="+environment.googleAPIKey+"&libraries=places&callback=initMap";
    // Verificar si el script ya existe
    const existingScript = document.querySelector(`script[src^="${scriptSrc}"]`);
    if (existingScript) {
      this.initMap();
      return;
    } else {
      // Create the script tag, set the appropriate attributes
      let script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key="+environment.googleAPIKey+"&libraries=places&callback=initMap";
      script.async = true;
      // Attach your callback function to the `window` object
      (<any>window).initMap = () => {
        // JS API is loaded and available
        this.initMap();
      };
      script.onload = () => {
        console.log("Script loaded successfully!");
      };
      // Append the 'script' element to 'head'
      document.head.appendChild(script);
    }
  }*/
}
